import { render } from "./PeritosPage.vue?vue&type=template&id=48de1874"
import script from "./PeritosPage.vue?vue&type=script&lang=js"
export * from "./PeritosPage.vue?vue&type=script&lang=js"

import "./PeritosPage.vue?vue&type=style&index=0&id=48de1874&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__